module.exports = __webpack_public_path__ + "img/calendar.3b421427.svg";